/*
 * @providesModule CountryPicker
 * 
 */

import React, {Component} from 'react';
import {Picker} from '@react-native-picker/picker';

import Country from 'Country';
import {_m} from 'INTL';
import PropTypes from 'prop-types';
import styles from 'PhoneInputStyle';

import {
  Modal,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

const PickerItem = Picker.Item;


export default class CountryPicker extends Component {
  static propTypes = {
    buttonColor: PropTypes.string,
    labels: PropTypes.array,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    itemStyle: PropTypes.object,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    selectedCountry: PropTypes.object,
    buttonTextStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    pickerBackgroundColor: PropTypes.string,
  }

  constructor(props: any) {
    super(props);

    this.state = {
      buttonColor: this.props.buttonColor || '#007AFF',
      modalVisible: false,
      selectedCountry: this.props.selectedCountry || Country.getAll()[0],
    };

    this.onPressCancel = this.onPressCancel.bind(this);
    this.onPressSubmit = this.onPressSubmit.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
  }

  static getDerivedStateFromProps(props: Object, state: Object): Object {
    if (props.selectedCountry !== state.selectedCountry) {
      return {
        selectedCountry: state.selectedCountry,
      };
    }
    return null;
  }

  selectCountry(selectedCountry: string) {
    this.setState({
      selectedCountry,
    });
  }

  onPressCancel() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }

    this.setState({
      modalVisible: false,
    });
  }

  onPressSubmit() {
    this.props?.onSubmit(this.state.selectedCountry);

    this.setState({
      modalVisible: false,
    });
  }

  onValueChange(selectedCountry: string) {
    this.setState({
      selectedCountry,
    });
  }

  show() {
    this.setState({
      modalVisible: true,
    });
  }

  static renderItemAndroid(country: Object, index: number): React.ReactNode {
    return (
      <Picker.Item key={country.iso2}
                   value={country.iso2}
                   label={country.name} />
    );
  }

  renderItem(country: Object, index: number): React.ReactNode {
    return (
      <PickerItem key={country.iso2}
                  value={country.iso2}
                  label={country.name} />
    );
  }

  render(): React.ReactNode {
    const {buttonColor} = this.state;
    const itemStyle = this.props.itemStyle || {};
    return (
      <Modal animationType={'slide'}
             transparent
             visible={this.state.modalVisible}
             onRequestClose={() => { console.debug('Country picker has been closed.'); }}>
        <View style={styles.basicContainer}>
          <View style={[styles.modalContainer, {backgroundColor: this.props.pickerBackgroundColor || 'white'}]}>
            <View style={styles.buttonView}>
              <TouchableOpacity onPress={this.onPressCancel}
                                accessible={true}
                                accessibilityRole={'button'}
                                testID={'country_picker_cancel'}
                                accessibilityLabel={this.props.cancelText || _m('Cancel')}>
                <Text style={[{color: buttonColor}, this.props.buttonTextStyle]}>
                  {this.props.cancelText || _m('Cancel')}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity onPress={this.onPressSubmit}
                                accessible={true}
                                accessibilityRole={'button'}
                                testID={'country_picker_confirm'}
                                accessibilityLabel={this.props.confirmText || _m('Confirm')}>
                <Text style={[{color: buttonColor}, this.props.buttonTextStyle]}>
                  {this.props.confirmText || _m('Confirm')}
                </Text>
              </TouchableOpacity>
            </View>

            <View style={styles.mainBox}>
              <Picker style={styles.bottomPicker}
                      selectedValue={this.state.selectedCountry}
                      onValueChange={(country: Object): void => this.onValueChange(country)}
                      itemStyle={itemStyle}
                      mode="dialog"
                      testID={'country_picker'}>
                {Country.getAll().map((country: Object, index: number): React.ReactElement => this.renderItem(country, index))}
              </Picker>
            </View>
          </View>
        </View>
      </Modal>
    );
  }
}
